import { Action, createReducer, on } from "@ngrx/store";
import { CaptchaActions } from "../actions";
import { VerifyChallengeOutput } from "@smash-sdk-private/captcha/ejs/10-2025";

export const captchaFeatureKey = 'captcha';

export interface State {
    verifyCaptchaResponse: VerifyChallengeOutput['challenge']['status'];
    verifyCaptchaStarted: boolean;
    verifyCaptchaLoading: boolean;
    verifyCaptchaLoaded: boolean;
    verifyCaptchaError: any;
}

export const initialState: State = {
    verifyCaptchaResponse: null,
    verifyCaptchaStarted: false,
    verifyCaptchaLoading: false,
    verifyCaptchaLoaded: false,
    verifyCaptchaError: null,
};

export const captchaReducer = createReducer(
    initialState,
    on(CaptchaActions.ResetVerifyCaptcha, (state) => ({
        ...state,
        verifyCaptchaResponse: initialState.verifyCaptchaResponse,
        verifyCaptchaStarted: initialState.verifyCaptchaStarted,
        verifyCaptchaLoading: initialState.verifyCaptchaLoading,
        verifyCaptchaLoaded: initialState.verifyCaptchaLoaded,
        verifyCaptchaError: initialState.verifyCaptchaError,
    })),
    on(CaptchaActions.StartVerifyCaptcha, (state) => ({
        ...state,
        verifyCaptchaResponse: initialState.verifyCaptchaResponse,
        verifyCaptchaStarted: true,
        verifyCaptchaLoading: initialState.verifyCaptchaLoading,
        verifyCaptchaLoaded: initialState.verifyCaptchaLoaded,
        verifyCaptchaError: initialState.verifyCaptchaError,
    })),
    on(CaptchaActions.VerifyCaptcha, (state) => ({
        ...state,
        verifyCaptchaResponse: initialState.verifyCaptchaResponse,
        verifyCaptchaStarted: true,
        verifyCaptchaLoading: true,
        verifyCaptchaLoaded: initialState.verifyCaptchaLoaded,
        verifyCaptchaError: initialState.verifyCaptchaError,
    })),
    on(CaptchaActions.VerifyCaptchaSuccess, (state, { result }) => ({
        ...state,
        verifyCaptchaResponse: result,
        verifyCaptchaStarted: false,
        verifyCaptchaLoading: false,
        verifyCaptchaLoaded: true,
    })),
    on(CaptchaActions.VerifyCaptchaFailure, (state, { error }) => ({
        ...state,
        verifyCaptchaLoading: false,
        verifyCaptchaStarted: false,
        verifyCaptchaError: error,
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return captchaReducer(state, action);
}
